import { useEffect, useState } from "react";
import { getCountries } from "slices/profileSlice";

let cache = [];
let request = null;

export function loadCountries() {
  if (!request) {
    request = getCountries()
      .then((res) => {
        if (!Array.isArray(res)) {
          console.error("[useCountries] /api/country/ did not return a list:", res);
          request = null;   // allow a retry
          return [];
        }
        cache = res;
        return cache;
      })
      .catch((error) => {
        console.error("[useCountries] Failed to load countries:", error);
        request = null;     // allow a retry
        return [];
      });
  }
  return request;
}

export default function useCountries() {
  const [countries, setCountries] = useState(cache);

  useEffect(() => {
    let active = true;
    loadCountries().then((list) => {
      if (active) setCountries(list);
    });
    return () => {
      active = false;
    };
  }, []);

  return countries;
}
